/**
 * Danh sách khung xuất cho khu vực "Tải về" ở màn Kết quả — theo docs/72-growth-viral.md §4.1
 * và tên gọi khung theo mục đích ở nhiệm vụ Phase 4c/7b.
 *
 * QUAN TRỌNG: đây là metadata thuần cho UI, KHÔNG import `@qrstudio/creative-renderer` (package
 * đó có `listExportFrames()`/`renderFrames()` với đúng 5 khung này, nhưng gói package không được
 * đưa thẳng vào frontend theo phạm vi nhiệm vụ — mọi render phải qua HTTP API của apps/api).
 *
 * Đã xác nhận bằng curl (2026-08-27): `POST /api/v1/qr/render` là endpoint DUY NHẤT đang tồn tại
 * để lấy SVG có template, và nó CHỈ render đúng khung gốc của template (không nhận tham số
 * `frame`/`watermark`). KHÔNG có endpoint đa khung nào ở apps/api hiện tại (thử
 * `/qr/render/frames`, `/qr/frames`, `/export/frames`, `/qr/export` đều 404) — dù package
 * `@qrstudio/creative-renderer` NỘI BỘ đã có sẵn `renderFrames()`/`listExportFrames()` hỗ trợ đủ
 * 5 khung + watermark, apps/api chưa expose ra HTTP. Vì vậy chỉ khung TRÙNG với
 * `TemplateSummary.aspectRatio` của mẫu đang chọn là khả dụng thật (dùng lại ảnh đã render sẵn
 * hoặc gọi lại /qr/render bình thường); 4 khung còn lại hiển thị trạng thái "sắp có".
 */

export type ExportFrame = "4:5" | "1:1" | "9:16" | "a4" | "card";

export type FrameOption = {
  frame: ExportFrame;
  /** Nhãn theo mục đích sử dụng, tiếng Việt — dễ hiểu hơn tỉ lệ khung kỹ thuật. */
  label: string;
  /** Mô tả phụ ngắn, hiện dưới nhãn. */
  hint: string;
};

export const FRAME_OPTIONS: FrameOption[] = [
  { frame: "4:5", label: "Đăng Facebook", hint: "Tỉ lệ 4:5 — vừa khung Feed điện thoại" },
  { frame: "1:1", label: "Instagram / Zalo", hint: "Tỉ lệ 1:1 — vuông, đăng được cả hai" },
  { frame: "9:16", label: "Story / TikTok", hint: "Tỉ lệ 9:16 — dọc full màn hình" },
  { frame: "a4", label: "In khổ A4", hint: "Độ phân giải cao để in giấy A4" },
  { frame: "card", label: "Card visit", hint: "Kích thước card visit 9x5.4cm" },
];

export function frameLabel(frame: ExportFrame): string {
  return FRAME_OPTIONS.find((f) => f.frame === frame)?.label ?? frame;
}
